module.exports = __webpack_public_path__ + "40972308381b6702715cf0e43e5c6405.pdf";